export type Availability = "available" | "held" | "sold_out";

export type AvailabilityFields = {
  inventory_quantity?: number | null;
  held_quantity?: number | null;
  next_release_at?: string | null;
};

export const HELD_LABEL = "Held by others";
export const HELD_POLL_MS = 10000;

export function showAvailability(show: AvailabilityFields | null | undefined): Availability {
  const inventory = show?.inventory_quantity;
  if (inventory == null || inventory > 0) return "available";
  return (show?.held_quantity ?? 0) > 0 ? "held" : "sold_out";
}

// Rolls child performances up: sold out only when every child is, held when none are available.
export function combinedAvailability(shows: AvailabilityFields[]): Availability {
  const states = shows.map(showAvailability);
  if (states.some((s) => s === "available")) return "available";
  if (states.some((s) => s === "held")) return "held";
  return "sold_out";
}

export function heldMessage(nextReleaseAt: string | null | undefined): string {
  const base = "All remaining tickets are held by other buyers.";
  const mins = nextReleaseAt ? (new Date(nextReleaseAt).getTime() - Date.now()) / 60000 : NaN;
  if (isNaN(mins) || mins < 1) return `${base} Some may free up in a moment.`;
  const rounded = Math.ceil(mins);
  return `${base} Some may free up in about ${rounded} minute${rounded === 1 ? "" : "s"}.`;
}
